import { cusStatusValues } from '@standandforce/api-contract';
import { z } from 'zod';
import { dataGridSearchFields } from '@/features/dynamic-table';
export const CustomerTableFilterSchema = z.object({
  ...dataGridSearchFields,
  freeText: z.string().optional(),
  // 初期ロード（パラメータ完全不在）= 既定で「有効（ACTIVE）」タブを選択。
  // 空配列 [] = ALL タブ（フィルタ未指定＝ BE 既定の非 TERMINATED 表示）。
  // 特定ステータス／TERMINATED を見たい場合のみ明示的に指定する。
  cusStatusIn: z.array(z.enum(cusStatusValues)).default(['ACTIVE'])
});
export type CustomerTableFilterSchema = z.infer<typeof CustomerTableFilterSchema>;